<template>
<b-modal
    id="formNotes"
    :title="($parent.isAdd?'Add':'Edit') + ' ' + $parent.pageTitle"
    centered
    no-close-on-backdrop
    hide-footer
    size="lg" :visible="true" :no-enforce-focus="true"
    @close="close" 
  >
  <b-overlay
    :show="$parent.loadingOverlay"
    rounded="sm"
  >
    <b-card v-if="!$parent.loadingOverlay" no-body class="m-0">
      <validation-observer
        v-slot="{ handleSubmit }" ref="VForm"
      >
        <b-form @submit.prevent="handleSubmit(doSubmitForm())">
          <b-card-body>
            <b-row>
              <b-col lg="4">
                <b-form-group>
                  <label>
                    {{ row.ar_is_repeat === 'Y' ? 'Start ' : '' }}Date 
                    <span class="text-danger mr5">*</span>
                  </label>
                  <date-picker prefix-class="crm" 
                    v-model="row.ar_event_date" 
                    type="date" value-type="format"
                    format="YYYY-MM-DD" placeholder="YYYY-MM-DD" 
                  />
                  <VValidate 
                    name="Date" 
                    v-model="row.ar_event_date" 
                    :rules="mrValidation.ar_event_date" 
                  />
                </b-form-group>
              </b-col>
              <b-col lg="4">
                <b-form-group>
                  <label>
                    {{ row.ar_is_repeat === 'Y' ? 'Start ' : '' }}Time 
                    <span class="text-danger mr5">*</span>
                  </label>
                  <date-picker prefix-class="crm" 
                    v-model="row.ar_event_time" 
                    type="time" value-type="format"
                    format="HH:mm" placeholder="HH:mm" 
                  />
                  <VValidate 
                    name="Time" 
                    v-model="row.ar_event_time" 
                    :rules="mrValidation.ar_event_time" 
                  />
                </b-form-group>
              </b-col>
              <b-col lg="4">
                <b-form-group>
                  <label>
                    Reminded Before 
                    <span class="text-danger mr5">*</span>
                  </label>
                  <b-input-group>
                    <b-form-input type="number" min="0" v-model="row.ar_remind_before_minutes" placeholder="e.g 1"></b-form-input>
                    <template #append>
                      <b-input-group-text>minutes</b-input-group-text>
                    </template>
                  </b-input-group>
                  <VValidate 
                    name="Reminded Before" 
                    v-model="row.ar_remind_before_minutes" 
                    :rules="mrValidation.ar_remind_before_minutes" 
                  />
                </b-form-group>
              </b-col>

              <b-col lg="12">
                <b-form-group>
                  <label>
                    Remind To 
                    <span class="text-danger mr5">*</span>
                  </label>
                  <v-select multiple v-model="row.ar_slack_assignees" placeholder="Select Slack Account" :options="mrSlackUsers" :reduce="v => v.user_id" label="user_name"></v-select>
                  <VValidate 
                    name="Remind To" 
                    v-model="row.ar_slack_assignees" 
                    :rules="mrValidation.ar_slack_assignees" 
                  />
                </b-form-group>
              </b-col>

              <div class="clearfix w-100 m-0"></div>
                
              <b-col lg="12">
                <b-form-group>
                  <b-form-checkbox v-model="row.ar_is_repeat" name="ar_is_repeat" switch value="Y" unchecked-value="N">
                    Repeat
                  </b-form-checkbox>
                  <VValidate 
                    name="Repeat" 
                    v-model="row.ar_is_repeat" 
                    :rules="mrValidation.ar_is_repeat" 
                  />
                </b-form-group>
              </b-col>

              <template v-if="row.ar_is_repeat === 'Y'">
                <b-col lg="4">
                  <b-form-group>
                    <label>
                      Repeat Every 
                      <span class="text-danger mr5">*</span>
                    </label>
                    <v-select v-model="row.ar_repeat_every" placeholder="Select" :options="mrRepeatCategory"></v-select>
                    <VValidate 
                      name="Repeat Every" 
                      v-model="row.ar_repeat_every" 
                      rules="required"
                    />
                  </b-form-group>
                </b-col>
                <b-col lg="4">
                  <b-form-group>
                    <label>
                      On 
                      <span class="text-danger mr5">*</span>
                    </label>
                    <b-form-input :value="labelRepeatOn" readonly/>
                  </b-form-group>
                </b-col>

                <div class="clearfix w-100 m-0"></div>

                <b-col lg="4">
                  <b-form-group>
                    <label>
                      Ends 
                      <span class="text-danger mr5">*</span>
                    </label>
                    <v-select v-model="row.ar_repeat_end" placeholder="Select" :options="mrRepeatEnd" :reduce="v => v.value" label="text"></v-select>
                    <VValidate 
                      name="Ends" 
                      v-model="row.ar_repeat_end" 
                      rules="required"
                    />
                  </b-form-group>
                </b-col>
                
                <b-col v-if="row.ar_repeat_end === 'DATE'" lg="4">
                  <b-form-group>
                    <label>
                      On 
                      <span class="text-danger mr5">*</span>
                    </label>
                    <date-picker prefix-class="crm" 
                      v-model="row.ar_repeat_end_after" 
                      type="date" value-type="format"
                      format="YYYY-MM-DD" placeholder="YYYY-MM-DD" 
                      :disabled-date="disableEndOn"
                    />
                    <VValidate 
                      name="On" 
                      v-model="row.ar_repeat_end_after" 
                      rules="required"
                    />
                  </b-form-group>
                </b-col>
              </template>
            </b-row>

            <hr/>

            <b-row>
              <b-col lg="8">
                <b-row>
                  <b-col lg="12">
                    <b-form-group>
                      <label>Title <span class="text-danger mr5">*</span></label>
                      <b-form-input v-model="row.ar_title" placeholder="e.g Title">
                      </b-form-input>
                      <VValidate 
                        name="Title" 
                        v-model="row.ar_title" 
                        :rules="mrValidation.ar_title" 
                      />
                    </b-form-group>
                  </b-col>
                  <b-col lg="12">
                    <b-form-group>
                      <label>Description <span class="text-black mr5">(Optional)</span></label>
                      <b-form-textarea v-model="row.ar_description" placeholder="e.g Title">
                      </b-form-textarea>
                      <VValidate 
                        name="Description" 
                        v-model="row.ar_description" 
                        :rules="mrValidation.ar_description" 
                      />
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group>
                      <label>Tags <span class="text-black mr5">(Optional)</span></label>
                      <input-tag v-model="row.ar_tags"></input-tag>
                      <VValidate 
                        name="Tags" 
                        v-model="row.ar_tags" 
                        :rules="mrValidation.ar_tags" 
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
              <b-col lg="4">
                <b-row>
                  <b-col md="12">
                    <b-form-group>
                      <label>Status <span class="text-danger mr5">*</span></label>
                      <v-select v-if="isForceInactive" disabled
                        value="N" placeholder="Select" :options="mrStatus" :reduce="v => v.value" label="text"></v-select>
                      <v-select v-else
                        v-model="row.ar_is_active" placeholder="Select" :options="mrStatus" :reduce="v => v.value" label="text"></v-select>
                      <VValidate 
                        name="Status" 
                        v-model="row.ar_is_active" 
                        :rules="mrValidation.ar_is_active" 
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group>
                      <label>Creator <span class="text-danger mr5">*</span></label>
                      <b-form-input v-model="row.ar_creator" placeholder="e.g Creator">
                      </b-form-input>
                      <VValidate 
                        name="Creator" 
                        v-model="row.ar_creator" 
                        :rules="mrValidation.ar_creator" 
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-card-body>
          <b-card-footer>
            <b-row>
              <b-col lg="12" class="text-right">
                <button @click="close" type="button" class="btn  btn-rounded  btn-default mr-3">Cancel</button>
                <b-button type="submit" variant="info" class="btn-rounded">Save Changes</b-button>
              </b-col>
            </b-row>
          </b-card-footer>
        </b-form>
      </validation-observer>
    </b-card>
  </b-overlay>
</b-modal>
</template>

<script>
import Gen from '@/libs/Gen'
import $ from 'jquery'
const _ = global._

export default{
  props: {
    rowModal: Object,
    pageSlug: String
  },
  data() {
    return {
      row:{},
      mrValidation:{},
      Config:{},
      mrSlackUsers: [],
      mrRepeatCategory: [
        'DAILY',
        'WEEKLY',
        'MONTHLY',
        'YEARLY'
      ],
      mrRepeatEnd: [
        { value: 'NEVER', text: 'NEVER'},
        { value: 'DATE', text: 'ON DATE'}
      ],
      mrStatus: [
        { value: 'Y', text: 'ACTIVE'},
        { value: 'N', text: 'INACTIVE'}
      ]
    }
  },
  computed: {
    isForceInactive() {
      if (this.row.ar_is_repeat === 'N') {
        return (
          this.row.ar_event_date < this.$moment().format('YYYY-MM-DD') ||
          (
            this.row.ar_event_date === this.$moment().format('YYYY-MM-DD') &&
            this.row.ar_event_time <= this.$moment().format('HH:mm')
          )
        )
      } else {
        return false
      }
    },
    valueRepeatOn() {
      if (this.row.ar_is_repeat === 'Y') {
        if (this.row.ar_repeat_every === 'DAILY') {
          return 'DAILY'
        } else if (this.row.ar_repeat_every === 'WEEKLY') {
          return this.$moment(this.row.ar_event_date).format('dddd').toUpperCase()
        } else if (this.row.ar_repeat_every === 'MONTHLY') {
          return this.$moment(this.row.ar_event_date).format('DD')
        } else if (this.row.ar_repeat_every === 'YEARLY') {
          return this.$moment(this.row.ar_event_date).format('DD-MM')
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    labelRepeatOn() {
      if (this.row.ar_is_repeat === 'Y') {
        if (this.row.ar_repeat_every === 'DAILY') {
          return 'EVERY DAY'
        } else if (this.row.ar_repeat_every === 'WEEKLY') {
          return this.$moment(this.row.ar_event_date).format('dddd').toUpperCase()
        } else if (this.row.ar_repeat_every === 'MONTHLY') {
          return this.$moment(this.row.ar_event_date).format('Do')
        } else if (this.row.ar_repeat_every === 'YEARLY') {
          return this.$moment(this.row.ar_event_date).format('Do of MMMM')
        } else {
          return ''
        }
      } else {
        return ''
      }
    }
  },
  mounted() {
    this.$parent.loadingOverlay = true
    this.getRow()
  },
  methods:{
    disableEndOn(date) {
      return date <= new Date(this.row.ar_event_date)
    },
    getRow(){
      this.$parent.loadingOverlay = true
      this.row = {}
      let slugs = (this.pageSlug?"/"+this.pageSlug:"")
      Gen.apiRest(
        "/get/"+this.$parent.modulePage+
        slugs, 
        {
          params: Object.assign({}, this.apiParams, {})
        }
      ).then(res=>{
        this.$parent.loadingOverlay = false

        _.forEach(res.data, (v,k)=>{
          this.$set(this, k, v)
        })

        this.$parent.setFocusForm()
        
      }).catch(()=>{
        this.$parent.loadingOverlay = false
      })
    },
    close() {
      this.$emit('update:pageSlug', 'canceled')
      this.$nextTick(() => {
        this.$router.back()
      })
    },
    doSubmitForm(){
      const input = _.clone(this.row)
      input.ar_event_date = this.$moment(input.ar_event_date).format('YYYY-MM-DD')
      input.ar_is_active = this.isForceInactive ? 'N' : input.ar_is_active
      input.ar_repeat_on = this.valueRepeatOn

      return this.$parent.doSubmit(
          "/do/BoReminder",
          _.assign({type:this.$parent.isAdd?'add':'update'}, {id: (this.pageSlug)}, input), 
          (type, resp)=>{
            if(type=='success'){
              this.$emit('update:pageSlug', 'updated')

              if (!this.$parent.isAdd && this.rowModal) {
                if (this.rowModal.ar_id === this.row.ar_id) {
                  this.$emit('update:rowModal', this.row)
                }
              }

              if(this.isAccountSetting){
                location.reload()
              }else{
                this.$router.push({name:this.$route.name})
              }
            }else{
              if(resp.response.status==422) {
                if((_.values(resp.response.data)[0][0]||"").indexOf('validation')>-1){
                  var msg = ""
                  $.each(Object.keys(resp.response.data),(i,v)=>{
                    msg = msg+" <br/>"+v+" : "+_.values(resp.response.data[v])
                  })
                  return this.$swal("Blocked With Validation!", msg)
                }else{
                  return this.$swal("Sorry, There is something wrong!", _.values(resp.response.data)[0][0])
                }
              }else if(resp.response.status==400){
                return this.$swal({
                  title: resp.response.data.message,
                  icon: 'error',
                  confirmButtonText: 'Ok'
                })
              }
            }
          },
          'POST', 'VForm', this.$refs
      )
    }
  }
}
</script>